import React from 'react';
import BEM from '../../bem';
import tzTime from '../../utils/tzTime';
import type { SourceMessage } from '../../../types/Tasks/sourceMessage';

const classes = BEM.with('TaskView');

type SourceMessageCardProps = {
  message: SourceMessage;
  onClick: () => void;
};

const MAX_BODY_LENGTH = 120;

export default function SourceMessageCard({ message, onClick }: SourceMessageCardProps) {
  const snippet =
    message.body.length > MAX_BODY_LENGTH
      ? `${message.body.slice(0, MAX_BODY_LENGTH)}…`
      : message.body;

  const timeLabel = tzTime(message.createdAt).format('MMM D, YYYY h:mm A');
  const senderName = message.sender?.displayName ?? 'Unknown';

  return (
    <button
      className={classes('card')}
      onClick={onClick}
      type="button"
      data-test-id="source-message-card"
    >
      <div className={classes('message')}>
        <span className={classes('message--sender')}>{senderName}</span>
        <span className={classes('message--body')}>{snippet}</span>
        <span className={classes('message--time')}>{timeLabel}</span>
      </div>
    </button>
  );
}
